import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

/* 
By default shareReplay will use refCount of false, meaning that it will not unsubscribe 
the source when the reference counter drops to zero, i.e. the inner ReplaySubject 
will not be unsubscribed (and potentially run for ever). 
This is the default as it is expected that shareReplay is often used to keep around 
expensive to setup observables which we want to keep running instead of having 
to do the expensive setup again.
*/
export function shareReplayWithRefCount<T>(): (
  source: Observable<T>,
) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    source.pipe(shareReplay({ bufferSize: 1, refCount: true }));
}
